(ns practitest.frontend.components2.grid
  (:require ["react-sortable-hoc" :as react-sortable-hoc]
            [clojure.string :as str]
            [goog.object :as gobj]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [format-translation get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.components.grid :as oldgrid]
            [practitest.frontend.components.grid.columns-settings :as oldsettings]
            [practitest.frontend.components.grid.filters :as oldfilters]
            [practitest.frontend.components.grid.server :as server]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.navigation :as navigation]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.components.overflow :as overflow]
            [practitest.frontend.components.overlay2 :as overlay2]
            [practitest.frontend.components.spinners :refer [inline-spinner-border]]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.grid.common :as gc]
            [practitest.frontend.components2.grid.fields]
            [practitest.frontend.components2.grid.filters :as filters]
            [practitest.frontend.components2.misc-components :as misc-components]
            [practitest.frontend.components2.pagination :as pagination]
            [practitest.frontend.components2.search-box :as search-box]
            [practitest.frontend.components2.spinners :refer [mux-spinner]]
            [practitest.frontend.routing.router :as router]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]
            [reagent.dom]))

(def checkbox-column-width 50)
(def mixpanel-grid-action "Grid Actions")

(defn table-header
  [table-props column]
  (let [state (reagent/atom {})
        th-ref (atom nil)]
    (fn [{:keys [columns-widths-save
                 resizable?
                 sort-order-save
                 full-data?
                 local-state-updating
                 hide-header-controls?]
          :as   grid-props}
         {:keys [header
                 field
                 sortable?
                 autofilter?]
          :as   column
          :or   {sortable? true}}]
      (let [hover? (:hover? @state)
            minimum-column-width 50

            [sort-column direction] (:sort-settings @local-state-updating)
            sorted? (= sort-column field)
            sort-trigger-fn (fn [e]
                              (mixpanel/track mixpanel-grid-action {"Action" "Sort"})
                              (swap! local-state-updating
                                     assoc :sort-settings
                                     ;; It's asc by default for new sort
                                     [field (if (or (not= field sort-column)
                                                    (= direction :desc))
                                              :asc
                                              :desc)])

                              (when sort-order-save
                                (sort-order-save (:sort-settings @local-state-updating)))

                              ;; Resend query when sorting changes
                              (when-not full-data?
                                (server/query-changed grid-props)))]
        [:th
         {:class (dom/classes-pairs-v :non-resizable (not resizable?))
          :style {:width (str (:width column) "px")}
          :ref           #(reset! th-ref %)
          :key           (str field)
          :on-mouse-over (fn [e]
                           (swap! state assoc :hover? true))
          :on-mouse-out  (fn [e]
                           (swap! state assoc :hover? false))}

         [:div.table-header-cell
          [overflow/overflow-with-mux-tooltip
           {}
           (fn [props]
             [:span.header-text
              (cond-> props

                      sortable?
                      (assoc :on-click sort-trigger-fn
                             ;; Add underline decoration on hover
                             :class "sorting-span"))
              header])
           header]

          (when-not hide-header-controls?
            [:div.header-controls
             (when sorted?
               [:span.sort-direction-icon
                {:on-click sort-trigger-fn}
                (if (= direction :asc)
                  [icons/mux-grid-arrow-up]
                  [icons/mux-grid-arrow-down])])

             ;; Disabled for now
             (when autofilter?
               [gc/filter-control grid-props column])])

          (when resizable?
            [tooltip/mux-tooltip
             {:position "top"}
             "Click to resize"
             (fn [props]
               [:span.resize-handle
                (assoc props
                  :on-mouse-down (fn [e]
                                   ;; Prevent text selection
                                   (dom/prevent-default e)

                                   ;; save starting X and width
                                   (let [startX (.-pageX e)
                                         startWidth (:width column)
                                         calc-new-width (fn [x]
                                                          (max minimum-column-width (+ startWidth (- x startX))))
                                         column-id (:field column)]
                                     (oldgrid/start-dragging
                                       (fn [x]
                                         (when-let [table-node @th-ref]
                                           ;; Use DOM mutation to speedup table updates here
                                           (.setProperty (.-style table-node)
                                                         "width" (str (calc-new-width x) "px"))))
                                       (fn [x]
                                         (mixpanel/track mixpanel-grid-action {"Action" "Resize"})

                                         ;; Save resulting length in an atom
                                         (swap! local-state-updating update :columns-widths assoc column-id (calc-new-width x))
                                         (when columns-widths-save
                                           (columns-widths-save (:columns-widths @local-state-updating)))))))
                  :class (dom/classes-pairs-v :hover hover?))])])]]))))

(defn row-selector [{:keys [selected? disabled? disabled-tooltip on-change]
                     :as props}]
  [:input.m-checkbox
   {:type      "checkbox"
    :checked   @selected?
    :disabled  disabled?
    :title (when disabled? disabled-tooltip)
    :on-change on-change}])

(defn- process-rows [rows local-state-updating local-columns]
  (let [[sort-column direction] (:sort-settings @local-state-updating)

        ;; Apply filters
        rows (oldfilters/apply-filters rows local-state-updating local-columns)

        ;; Apply sort
        rows (if sort-column
               (let [column-info (first (filter #(= (:field %) sort-column) local-columns))]
                 (sort (fn [x y]
                          (gc/compare-fn column-info direction x y))
                       rows))

               rows)]

    (vec rows)))

(def DragHandle
  (react-sortable-hoc/sortableHandle.
   (fn [props]
     (let [tooltip-text (gobj/get props "tooltip-text")
           disabled? (gobj/get props "disabled")
           invisible? (gobj/get props "invisible")
           hover? (gobj/get props "hover")]
       (reagent/as-element
        [tooltip/mux-tooltip
         {:position "top"}
         tooltip-text
         (fn [props]
           [:span.grid-drag-handle
            (assoc props
                   :class (dom/classes-pairs-v :disabled disabled?
                                               :invisible invisible?
                                               :hover hover?))
            [icons/mux-drag-handle]])])))))

(defn handle-drag-start [e row selected-rows grid-props row-state]
  (let [all-rows (:data grid-props)
        all-ids (map :id all-rows)
        dragged-rows (if (= (:selection grid-props) :_all)
                       (map (fn [r] {:id r}) all-ids)
                       (if (contains? selected-rows (:id row))
                         (map (fn [r] {:id r}) selected-rows)
                         [{:id (:id row)}]))
        entity-type (:module @(:grid-state grid-props))
        target-row-id (:id row)
        target-row (.querySelector js/document (str "[data-row-id='" target-row-id "']"))
        total-count (:total-count grid-props)
        selection (:selection grid-props)
        row-count (if (= selection :_all) total-count (count dragged-rows))
        drag-container (.createElement js/document "div")
        container-text (str "Move " row-count " " entity-type (when (> row-count 1) "s"))
        icon-container (.createElement js/document "div")
        text-node (.createTextNode js/document container-text)
        icon-component (if (= entity-type "TestSet")
                         icons/mux-testsets-runs
                         icons/mux-test-library)]

    (aset drag-container "className" "drag-container")
    (reagent.dom/render [icon-component] icon-container)
    (.appendChild drag-container icon-container)
    (.appendChild drag-container text-node)
    (.appendChild js/document.body drag-container)
    (.setDragImage (.-dataTransfer e) drag-container -45 10)
    ;; Set drag data
    (.setData (.-dataTransfer e) "application/json"
              (js/JSON.stringify (clj->js {:rows dragged-rows
                                           :entity-type entity-type})))
    ;; Disable dragged rows in the grid
    (doseq [row-id (map :id dragged-rows)]
      (when-let [row-element (.querySelector js/document (str "[data-row-id='" row-id "']"))]
        (.add (.-classList row-element) "table-disabled-row")
        (when-let [checkbox (.querySelector row-element "input[type='checkbox']")]
          (aset (.-style checkbox) "opacity" "0.3"))))))

(defn handle-drag-end [e row-state]
  ;; Enable rows when drag is over
  (doseq [row-element (array-seq (.querySelectorAll js/document "[data-row-id]"))]
    (.remove (.-classList row-element) "table-disabled-row")
    (when-let [checkbox (.querySelector row-element "input[type='checkbox']")]
      (aset (.-style checkbox) "opacity" "")))

  (doseq [drag-element (array-seq (.querySelectorAll js/document ".drag-container"))]
    (.remove drag-element)))

;; TODO: rework whole added-tests / added-row-tooltip etc
(defn table-row
  [_ _]
  (let [row-state (reagent/atom {})]
    (fn [{:keys [on-row-click
                 selected?
                 shown-columns
                 on-sort-end
                 selection
                 toggle-selection
                 disabled-row?
                 disabled-row-tooltip
                 added-row-tooltip
                 alt-highlight-row?
                 expandable-row?
                 expanded-row?
                 on-expand-row-click
                 added-tests
                 allows-added-rows?
                 testset-grid?]
          :as   grid-props}
         {:keys [row
                 even?
                 tooltip-text
                 disabled?]
          :as   row-props}]
      (let [hover? (:hover? @row-state)
            selection-disabled? (and disabled-row? (disabled-row? row))
            added-row? (or (contains? added-tests (:display_id row))
                           (and alt-highlight-row? (alt-highlight-row? row)))
            current-tab (:current-view grid-props)
            expandable-row? (when expandable-row?
                              @(expandable-row? row))
            expanded-row? (when expanded-row?
                            @(expanded-row? row))
            entity-type (some-> grid-props :grid-state deref :module)
            enable-drag? (and (or (= entity-type "Test") (= entity-type "TestSet")) (= current-tab "folders"))
            row-selector-with-drag-handle
            (when selected?
              [:div.selection-column-container
               (when expandable-row?
                 [:span.expandable-row-clicker
                  {:on-click (fn [e]
                               (when on-expand-row-click
                                 (on-expand-row-click e row)))}
                  (if expanded-row?
                    [icons/mux-chevron-down2]
                    [icons/mux-chevron-right])])

               [:r> DragHandle #js {:tooltip-text tooltip-text
                                    :disabled     disabled?
                                    :hover        hover?
                                    ;; We want to hide it in this case
                                    ;; But if we remove it from DOM it messes up layout
                                    :invisible    (nil? on-sort-end)}]
               [row-selector {:selected? (selected? (:id row))
                              :disabled? selection-disabled?
                              :on-change (fn [e]
                                           (toggle-selection (:id row)))}]])]
        (into [:tr
               {:draggable enable-drag?
                :data-row-id (:id row)
                :on-drag-start (fn [e] (handle-drag-start e row selection grid-props row-state))
                :on-drag-end   (fn [e] (handle-drag-end e row-state))
                :on-click      (fn [e]
                                 ;; Clear hover when clicking on form/input elements inside the row
                                 (let [target (.-target e)
                                       is-form-element? (or (= "input" (.-tagName target))
                                                           (= "select" (.-tagName target))
                                                           (= "textarea" (.-tagName target))
                                                           (some-> (.-closest target) (fn [f] (f "input, select, textarea, button, [role='button'], [role='combobox'], [role='listbox']"))))]
                                   (when is-form-element?
                                     (swap! row-state assoc :hover? false)))
                                 (when on-row-click
                                   (on-row-click e row)))
                :on-mouse-over (fn [e]
                                 (swap! row-state assoc :hover? true))
                :on-mouse-out  (fn [e]
                                 (swap! row-state assoc :hover? false))
                :on-mouse-leave (fn [e]
                                  (swap! row-state assoc :hover? false))
                :class         (dom/classes-pairs-v
                                 :grid-row-even even?
                                 :hover hover?
                                 :table-selected-row (when selected? @(selected? (:id row)))
                                 :table-disabled-row selection-disabled?)}
              (when selected?
                (if selection-disabled?
                  [tooltip/mux-tooltip
                   {:position "top"}
                   (when (and disabled-row-tooltip selection-disabled?)
                     (disabled-row-tooltip row))
                   (fn [props]
                     [:td.selection-column
                      [:div.selection-data
                        (assoc props :id "tooltip")
                        row-selector-with-drag-handle]])]
                  (if (and allows-added-rows? added-row?)
                    [:td.selection-column
                     [:div.selection-data
                      row-selector-with-drag-handle
                      [:span.icon-info-container
                       [tooltip/mux-tooltip
                        {:position "top"}
                        added-row-tooltip
                        (fn [props]
                          [:span.icon-info
                           (assoc props :class "icon-info")
                           [icons/mux-info-circle]])]]]]
                    [:td.selection-column
                      [:div
                      {:class (dom/classes-pairs-v "selection-data-no-info" allows-added-rows?
                                                   "selection-data" (not testset-grid?))}
                        row-selector-with-drag-handle]])))]
              (map (fn [{:keys [field type text-align class] :as column}]
                     ;; Skip overflow wrapper for testset headers in hierarchical-name column
                     ;; (they have their own tooltip in the render function)
                     (let [td-props {:class (when class
                                              (dom/append-class
                                                class
                                                (dom/classes-pairs-v :row-hover hover?)))
                                     :style (when text-align
                                              {:text-align text-align})}
                           td-body [gc/body-fn column (assoc row :hover? hover?) grid-props]
                           testset-header? (and (= type :hierarchical-name) (:testset-header? row))]
                       (if testset-header?
                         [:td td-props td-body]
                         [overflow/overflow-with-mux-tooltip
                          {:field_type type}
                          (fn [props]
                            [:td (merge props td-props) td-body])
                          (gc/text-fn column row)])))
                   shown-columns))))))

(def SortableTableRow
  (react-sortable-hoc/SortableElement.
   (fn [props]
     (reagent/as-element
      (let [grid-props (gobj/get props "gridprops")
            row-props {:row (gobj/get props "value")
                       :tooltip-text (gobj/get props "dragHandleTooltip")
                       :disabled? (gobj/get props "disabled2")
                       :even? (gobj/get props "even?")}]
        [table-row grid-props row-props])))))

;; TODO: do not wrap in react-sortable-hoc if not required ?
(def SortableTableBody
  (react-sortable-hoc/SortableContainer.
   (fn [props]
     (let [{:keys [selected?
                   all-selected?
                   toggle-selection-page
                   disabled-select-all?
                   disabled-select-all-tooltip
                   loading?
                   total-count
                   full-data?
                   on-sort-end
                   reorder-in-progress?
                   empty-table-message
                   expandable-row-component
                   table-ref
                   has-filters?
                   has-sorting?
                   shown-columns
                   page-rows
                   no-reorder-permission]
            :as   grid-props} (gobj/get props "gridprops")
           empty-grid? (= 0 (or total-count 0))]
       (reagent/as-element
       [:<>
        [:table.new-grid
         {:style {:visibility (if loading?
                                "hidden"
                                "visible")}
          :ref #(reset! table-ref %)}
         [:thead
          (into [:tr
                 (when selected?
                   [:th.selection-header
                    [row-selector {:selected? (if empty-grid?
                                                (atom false)
                                                (all-selected? page-rows))
                                   :disabled? (and disabled-select-all? (disabled-select-all? page-rows))
                                   :disabled-tooltip disabled-select-all-tooltip
                                   :on-change (fn [e]
                                                (toggle-selection-page page-rows))}]])]
                (map (fn [column]
                       [table-header grid-props column]))
                shown-columns)]
         (let [tbody-rows (if (seq page-rows)
                            (map-indexed
                             (fn [idx row]
                               (let [disabled? (or (not on-sort-end)
                                                   has-filters?
                                                   has-sorting?
                                                   (not full-data?)
                                                   ;; Do not allow reordering while another reordering is ongoing
                                                   reorder-in-progress?
                                                   no-reorder-permission)
                                     even-row? (odd? idx)]
                                 [:<>
                                  [:r>
                                   SortableTableRow
                                   #js {:key               idx
                                        :index             idx
                                        :even?             even-row?
                                        :dragHandleTooltip (cond
                                                             has-filters?
                                                             (get-translation "generic.grid.reorder-tooltip.filters-applied"
                                                                              "Filters applied. To reorder, please reset the table using the Reset icon")

                                                             has-sorting?
                                                             (get-translation "generic.grid.reorder-tooltip.sort-applied"
                                                                              "Sorting applied. To reorder, please reset the table using the Reset icon")

                                                             (not full-data?)
                                                             (get-translation "generic.grid.reorder-tooltip.too-many-instances"
                                                                              "Too many instances for drag&drop reorder")

                                                             disabled?
                                                             (get-translation "generic.grid.reorder-tooltip.disable"
                                                                              "Reorder is disabled")

                                                             :else
                                                             (get-translation "generic.grid.reorder-tooltip.drag"
                                                                              "Drag to reorder"))
                                        ;; Only allow sorting for full-data mode and no filters applied
                                        :disabled          disabled?
                                        ;; react-sortable-hoc consumes "disabled" prop, but we still need to know
                                        ;; that we're disabled, so we're passing disabled2 prop as workaround
                                        :disabled2         disabled?
                                        :gridprops         (gobj/get props "gridprops")
                                        :value             row}]
                                  (when expandable-row-component
                                    [expandable-row-component grid-props idx row])]))
                             page-rows)
                            [])
               has-content? (not (empty? tbody-rows))]

           (if has-content?
             (into [:tbody] tbody-rows)
             ;; Empty table - only show if no filters are applied
             (when-not has-filters?
               [:tbody
                [:tr
                 [:td {:col-span (+ (count shown-columns)
                                    (if selected?
                                      1
                                      0))}
                  [:div.empty-table-message
                   empty-table-message]]]])))]])))))

(defn add-instances-button [{:keys [on-add-instance
                                    selected-tests
                                    adding-instances?
                                    local-state-updating
                                    total-count] :as tableprops}]
  (let [selected-view           (:selected-view-id @local-state-updating)
        selected-tests-count    (if selected-view total-count (count selected-tests))
        has-selected-tests?     (> selected-tests-count 0)
        disabled-state          (or adding-instances?
                                    (not has-selected-tests?))]
    [buttons/button
     {:disabled? disabled-state
      :primary? true
      :toolbar? true
      :on-click (fn [e]
                  (when on-add-instance
                    (on-add-instance selected-tests)))
      :icon (if adding-instances?
              [inline-spinner-border]
              [icons/add-plus-icon])
      :text (format-translation
              (get-translation "test.steps.call-to-test.add-selected-tests-count" "Add selected Tests %{count}")
              :count selected-tests-count)
      :size "large"}]))

(defn- process-columns [local-state-updating
                        pre-columns
                        columns
                        post-columns]
  (let [{:keys [columns-order
                columns-visibility
                columns-widths]} @local-state-updating

        all-columns (into {}
                          (map (fn [col]
                                 [(:field col) col]))
                          (concat pre-columns
                                  columns
                                  post-columns))
        columns-order (or columns-order
                          (mapv :field (sort-by :order columns)))

        columns-visibility (merge
                             ;; Default visibility map
                            (into {}
                                  (->> all-columns
                                       (mapv (fn [[field column]]
                                               [field (:default-show? column true)]))))
                            columns-visibility)

        ;; It's possible to have more columns in all-columns than in local collections
        columns-order (if (> (count columns) (count columns-order))
                        ;; Append new columns at the end of collection ?
                        ;; TODO: other merging strategy ?
                        ;; something like default-order custom-order fields ?
                        (let [all (set (map :field columns))
                              local (set columns-order)
                              new (clojure.set/difference all local)]
                          (apply conj columns-order new))

                        columns-order)

        ;; Handle pre and post columns
        columns-order (concat (map :field pre-columns)
                              columns-order
                              (map :field post-columns))

        ;; We need to merge all-columns list and our local settings overrides here
        local-columns (reduce
                       (fn [acc id]
                          ;; Search for column definition
                         (if-let [column (get all-columns id)]
                            ;; shown by default
                           (let [show? (boolean (get columns-visibility id true))]
                             (conj acc (assoc column :show? show?
                                                      ;; Width should always be present
                                              :width (or (get columns-widths id)
                                                         (:default-width column)
                                                         oldgrid/fallback-column-width))))

                            ;; Non-existent column (removed by server ?)
                           acc))
                       []
                       columns-order)]
    local-columns))

(defn- get-local-columns
  [{:keys [local-state-updating
           pre-columns
           columns
           post-columns]
    :as grid-props}]
  (process-columns local-state-updating pre-columns columns post-columns))

(defn get-local-rows
  [{:keys [local-state-updating

           full-data?
           data]
    :as grid-props}]
  (let [local-columns (get-local-columns grid-props)]
    (if full-data?
      (process-rows data local-state-updating local-columns)
      data)))

(defn add-cancel-component [{:keys [close-instances-dialog] :as grid-props}]
  [:div.add-cancel-component
    [gc/existing-instances-warning-note grid-props]
    [buttons/button
     {:toolbar? true
      :on-click #(close-instances-dialog)
      :size "large"
      :text (get-translation "generic.button.cancel" "Cancel")}]
    [add-instances-button grid-props]])

(defn- build-visibility-map
  [local-columns new-value]
  (zipmap (map :field local-columns)
          (repeat new-value)))

(defn edit-columns-menu-item
  [grid-props]
  (let [local-state (reagent/atom {})]
    (fn [{:keys [show-edit-columns?
                 local-state-updating] :as grid-props}]
      (when show-edit-columns?
        (let [show-edit? (:show-edit-columns? @local-state)
              hide-edit! (fn []
                           (swap! local-state
                                  (fn [state]
                                    (-> state
                                        (assoc :show-edit-columns? false)
                                        (dissoc :columns-visibility :columns-order)))))
              toggle-edit! (fn []
                             (swap! local-state
                                    (fn [state]
                                      (-> state
                                          (update :show-edit-columns? not)
                                          (assoc :columns-visibility (:columns-visibility @local-state-updating)
                                                 :columns-order (:columns-order @local-state-updating))))))]
          ;; TODO: overlay inside an overlay ?
          [overlay2/floating-ui-overlay
           {:placement "bottom-end"
            :show? show-edit?
            :on-request-close hide-edit!}

           ;; Menu item
           [navigation/menu-item-element {:text (get-translation "generic.grid-buttons.edit-columns" "Edit columns")
                                          :on-click (fn [e]
                                                      (mixpanel/track gc/mixpanel-grid-action {"Action" "Edit Columns"})
                                                      (toggle-edit!))
                                          :icon icons/mux-edit-columns}]

           [:div.column-settings-popover
            [:div.popover-header
             "Columns reordering"]

            ;; A bit complicated - we want to reuse usual column building logic, but use our "local" state
            ;; instead of currently applied grid state, hence this `:local-state-updating` override here
            (let [local-columns (get-local-columns (assoc grid-props :local-state-updating local-state))
                  ;; Excludes sys columns from the column editing panel.
                  local-columns        (vec (remove :systemcol? local-columns))
                  ;; Search functionality
                  search-query (get @local-state :column-search-query "")
                  filtered-columns (if (str/blank? search-query)
                                     local-columns
                                     (filter (fn [column]
                                               (let [header-text (gc/header-title column)]
                                                 (str/includes? (str/lower-case header-text) 
                                                               (str/lower-case search-query))))
                                             local-columns))
                  all-selected? (every? :show? filtered-columns)
                  some-selected? (boolean (some :show? filtered-columns))]
              [:div.popover-body.column-settings-body
               [:div.column-search-container
                [search-box/search-textbox
                 {:placeholder (get-translation "generic.fields.search" "Search Field")
                  :value search-query
                  :on-change (fn [e]
                               (swap! local-state assoc :column-search-query (dom/event-value e)))
                  :on-clear-click (fn [e]
                                    (swap! local-state dissoc :column-search-query))}]]
               
               [:div.grid-filter-controls
                [misc-components/link-button
                 {:disabled? all-selected?
                  :on-click (fn [e]
                              (swap! local-state assoc :columns-visibility
                                     (build-visibility-map filtered-columns true)))}
                 (get-translation "generic.button.select-all" "Select All")]
                [misc-components/link-button
                 {:class "pull-right"
                  :disabled? (not some-selected?)
                  :on-click (fn [e]
                              (swap! local-state assoc :columns-visibility
                                     (build-visibility-map filtered-columns false)))}
                 (get-translation "generic.button.clear" "Clear")]]
               [oldsettings/columns-settings-window2 grid-props local-state filtered-columns]])

            [:div.popover-footer
             [:div.column-settings-footer
              [misc-components/link-button
               {:on-click (fn [e]
                            (oldsettings/reset-saved-settings! grid-props)
                            (swap! local-state dissoc
                                   :columns-order
                                   :columns-visibility)
                            (swap! local-state-updating dissoc
                                   :columns-widths
                                   :columns-order
                                   :columns-visibility))}
               (get-translation "generic.button.reset" "Reset")]

              [buttons/button
               {:on-click (fn [e]
                            (hide-edit!))
                :class "pull-right"
                :text (get-translation "generic.button.cancel" "Cancel")}]

              [buttons/button
               {:primary? true
                :on-click (fn [e]
                            (swap! local-state-updating assoc
                                   :columns-order (:columns-order @local-state)
                                   :columns-visibility (:columns-visibility @local-state))
                            (oldsettings/save-settings! grid-props)
                            (hide-edit!))
                :text (get-translation "generic.button.apply" "Apply")}]]]]])))))

(defn default-grid-more-button
  [grid-props]
  (let [local-state (reagent/atom {})]
    (fn [{:keys [show-edit-columns?] :as grid-props}]
      (when show-edit-columns?
        (let [show? (:show-toolbar-menu? @local-state)
              hide! (fn []
                      (swap! local-state assoc :show-toolbar-menu? false))
              toggle! (fn []
                        (swap! local-state update :show-toolbar-menu? not))]
          [overlay2/floating-ui-overlay
           {:placement        "bottom-end"
            :strategy         "absolute"
            :offset           5
            :show?            show?
            :on-request-close hide!}

           ;; Target
           [:button.more-button
            {:on-click (fn [e]
                         (toggle!))}
            [icons/mux-three-dots]]

           ;; Menus
           [:div.menu-popup
            {:style {:width     "max-content"
                     :min-width "233px"}}

            ;; Edit columns menu item
            [edit-columns-menu-item grid-props]]])))))

(defn expand-button [{:keys [expanded? on-expand-click class]}]
  [tooltip/mux-tooltip
   {:position "top"}
   ;; TODO: fix annoying issue when you can see wrong tooltip for a split second after clicking on button
   (if expanded?
     (get-translation "grid.button.collapse" "Collapse")
     (get-translation "grid.button.expand" "Expand"))
   (fn [props]
     [:span.data-grid-header-button
      (assoc props :class class
                   :on-click (fn [e]
                               (mixpanel/track mixpanel-grid-action {"Action" (if expanded?
                                                                                "Collapse"
                                                                                "Expand")})
                               ;; A little backwards and hacky, but it's one way to fix annoying issue with stuck tooltip
                               (when-let [on-mouse-out (:onMouseOut props)]
                                 ;; Simulate on-mouse-out event to trigger hiding of tooltip in OverlayTrigger
                                 (on-mouse-out e))

                               (on-expand-click e)))
      (if expanded?
        [icons/mux-collapse]
        [icons/mux-expand])])])

;; MouseUX styled grid
(defn grid
  [{:keys [per-page-load
           current-page-load
           resizable?
           columns-widths-load
           columns-settings-load
           autofilters-load
           sort-order-load
           grid-state
           default-sort-settings]}]
  (let [table-ref (atom nil)
        tbody-ref (atom nil)
        local-state-updating (or grid-state
                                 (reagent/atom {}))
        table-container-ref (atom nil)]
    ;; Initial state
    (when per-page-load
      (swap! local-state-updating assoc :per-page (per-page-load)))

    (when current-page-load
      (swap! local-state-updating assoc :current-page (current-page-load)))

    (when (and resizable? columns-widths-load)
      (swap! local-state-updating assoc :columns-widths (columns-widths-load)))

    (when columns-settings-load
      (when-let [data (columns-settings-load)]
        (swap! local-state-updating
               merge
               (select-keys data [:columns-order
                                  :columns-visibility]))))
    (when autofilters-load
      (swap! local-state-updating assoc :autofilters-state (autofilters-load)))
    (when sort-order-load
      (swap! local-state-updating assoc :sort-settings (sort-order-load)))
    ;; Use default sort settings if provided
    (when (and (nil? (:sort-settings @local-state-updating))
               (some? default-sort-settings))
      (swap! local-state-updating assoc :sort-settings default-sort-settings))

    (fn [{:keys [data
                 columns
                 post-columns
                 pre-columns
                 grid-state
                 sort-order-save
                 loading?
                 on-sort-end
                 current-page
                 total-count
                 full-data?
                 on-query-changed
                 save-in-url?
                 class
                 show-add-cancel-component

                 selection
                 clear-selection
                 select-all
                 all-selected?
                 current-view

                 on-expand-click
                 expanded?
                 grid-toolbar
                 show-edit-columns?
                 hide-header-controls?
                 on-page-changed
                 current-page-save 
                 show-save-fast-filter?]
          :as   grid-props}]
      (let [local-state-updating (or grid-state local-state-updating) 
            local-columns (process-columns local-state-updating pre-columns columns post-columns)
            local-rows (if full-data?
                         (process-rows data local-state-updating local-columns)
                         data)

            shown-columns (filter :show? local-columns)
            per-page (or (:per-page grid-props) (:per-page @local-state-updating) server/default-per-page)
            current-page (or (:current-page @local-state-updating) current-page 1)
            total-count (if full-data?
                          (count local-rows)
                          total-count)
            total-pages (pagination/get-total-pages total-count per-page)
            ;; reset current page if filters caused dataset to shrink
            current-page (min current-page total-pages)
            page-rows (if full-data?
                        (pagination/get-current-page-items local-rows current-page per-page)
                        local-rows)

            has-sorting? (gc/has-any-sorting? local-state-updating)
            has-filters? (gc/has-any-filters? local-state-updating)

            grid-props (assoc grid-props
                              ;; TODO: replace with grid-state everywhere
                              :local-state-updating local-state-updating
                              :grid-state local-state-updating
                              :table-ref table-ref
                              :tbody-ref tbody-ref
                              :local-columns local-columns
                              :shown-columns shown-columns
                              :page-rows page-rows
                              :has-sorting? has-sorting?
                              :has-filters? has-filters?
                              :current-page current-page
                              :table-container-ref table-container-ref
                              :local-rows local-rows
                              :total-count total-count)
            no-data? (empty? page-rows)]
        [:div.data-grid-container.h-100
         {:ref #(reset! table-container-ref %)
          :class class}

         (when (and (not hide-header-controls?)
                   (not= false (:show-pagination? grid-props)))
           [:div.data-grid-header
            (when on-expand-click
              [:<>
               [expand-button {:expanded? expanded?
                               :on-expand-click on-expand-click}]
               [:span.tab-delimiter]
               [gc/reset-grid-filter-component grid-props]
               [:span.tab-delimiter]])

            [:div.pagination-control-container
              (let [show? (:show-per-row-selector? @local-state-updating)
                     toggle! #(swap! local-state-updating update :show-per-row-selector? not)
                     hide! #(swap! local-state-updating assoc :show-per-row-selector? false)]
                     [overlay2/floating-ui-overlay
                       {:placement        "bottom"
                        :show?            show?
                        :on-request-close hide!
                        :target-width?    true}
                     [pagination/per-page-picker {:per-page per-page
                                :no-data? no-data?
                                :local-state-updating local-state-updating}]
                    [pagination/per-page-dropdown grid-props]])
               [:span.tab-delimiter]

             [pagination/pagination-view {:current-page current-page
                                          :total-count total-count
                                          :per-page per-page
                                          :max-buttons 0
                                          :on-change (fn [page]
                                                       (mixpanel/track mixpanel-grid-action {"Action" "Paging"})
                                                       (when save-in-url?
                                                         (router/update-query-params! assoc :page page))
                                                       (swap! local-state-updating assoc :current-page page)
                                                       (when on-page-changed
                                                         (on-page-changed page))
                                                       (when current-page-save
                                                         (current-page-save page))
                                                       (when-not full-data?
                                                         (on-query-changed (server/build-query grid-props page))))}]]

          [:div.pull-right.all-available-width.justify-end
           (if grid-toolbar
             [grid-toolbar grid-props]

             ;; no grid toolbar but show-edit-columns? set to true - show edit columns menu
             (when show-edit-columns?
               [default-grid-more-button grid-props]))]])

         (when has-filters?
           [filters/filter-info-bar grid-props])

         ;; Special mode to "Select ALl in current View"
         ;; Not supported for every grid - only for specific ones (entities index grids mostly)
         (when (and (some? select-all)
                    (number? total-count)
                    (> total-count 0)
                    (> total-count per-page)
                    @(all-selected? page-rows))
           (let [selection-count (if (grid.subs/full-selection? selection)
                                   total-count
                                   (count selection))]
             (if (grid.subs/full-selection? selection)
               [:div.data-grid-selection-header
                ;; TODO: proper name for filters
                (if-let [name (:name current-view)]
                  [:span "All " total-count " items in View: " [:strong name] " are selected."]
                  [:span "All " total-count " items are selected."])

                [misc-components/link-button
                 {:on-click clear-selection}
                 "Clear Selection"]]

               [:div.data-grid-selection-header
                (if (> selection-count per-page)
                  [:span "All " per-page " (total " selection-count ") items on this page are selected."]
                  [:span "All " selection-count " items on this page are selected."])

                (when (< selection-count total-count)
                  (into [misc-components/link-button {:on-click select-all}]
                        (if-let [name (:name current-view)]
                          ["Select All " total-count " items in View: " [:strong (:name current-view)]]
                          ["Select All " total-count " items."])))])))

         (when loading?
           [:div
            {:class "grid-spinner-container"}
            [mux-spinner {:size "large"}]])
         [:div.data-grid-body
          {:ref #(reset! tbody-ref %)
           :class (dom/classes-pairs-v :expanded expanded?)}
          [:r> SortableTableBody #js {:gridprops grid-props
                                      :useDragHandle   true

                                      ;; We need to copy columns widths to newly-created helper element
                                      ;; https://github.com/clauderic/react-sortable-hoc/issues/361
                                      :onSortStart (fn [event]
                                                     (let [helper (.-helper event)
                                                           node (.-node event)]
                                                       ;; map-indexed doesn't work on childNodes for some reason
                                                       (.forEach (.-childNodes helper)
                                                                 (fn [element index]
                                                                   ;; Copy column widths
                                                                   (.setProperty (.-style element)
                                                                                 "width" (str (.-offsetWidth (aget (.-childNodes node) index)) "px"))))))

                                      :helperClass "sortable-row-helper"
                                      :helperContainer (fn []
                                                         @table-container-ref)

                                      :onSortEnd (fn [options]
                                                   (let [old (gobj/get options "oldIndex")
                                                         new (gobj/get options "newIndex")

                                                         ;; Calculate offset
                                                         offset (* (dec current-page) per-page)
                                                         totalold (+ offset old)
                                                         totalnew (+ offset new)]
                                                     (when on-sort-end
                                                       (mixpanel/track mixpanel-grid-action {"Action" "Reorder"})
                                                       (on-sort-end (oldsettings/vector-move local-rows totalold totalnew)))))}]]]))))

